import React, { useState, useEffect } from "react";
import Select from "react-select";
import AdminServices from "services/AdminServices";

const IndicatorSeparator = () => null;

const SelectStateCity = ({
  onSelectState,
  name,
  label,
  selectedServiceState = [],
  setSelectedServiceState,
  register,
  required,
}) => {
  const [states, setStates] = useState([]);

  // Fetch states on component mount
  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await AdminServices.getAllStateCity();

        if (Array.isArray(response.data)) {
          setStates(
            response.data.map((state) => ({
              value: state.id,
              label: state.name,
            }))
          );
        } else {
          console.error("API Response is not an array:", response);
        }
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };

    fetchStates();
  }, []);

  // Get selected options for react-select
  const getSelectedOptions = () => {
    return selectedServiceState
      .map((value) =>
        states.find((state) =>
          typeof value === "object"
            ? state.value === value.value
            : state.value.toString() === value.toString()
        )
      )
      .filter(Boolean);
  };

  // Handle selection changes
  const handleStateSelect = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => ({
      value: option.value,
      label: option.label,
    }));
    setSelectedServiceState(selectedValues); // Update parent state
    onSelectState(selectedValues); // Notify parent of the change
  };

  return (
    <div>
      {label && <label className="block text-sm font-medium">{label}</label>}
      <Select
        {...register(`${name}`, {
          ...(required && {
            required: `${label} is required!`,
          }),
        })}
        isMulti
        name={name}
        options={states} // Dropdown options
        value={getSelectedOptions()} // Pre-select values
        onChange={handleStateSelect} // Handle changes
        placeholder="Select States and City"
        classNamePrefix="react-select"
        components={{
          IndicatorSeparator, // Hides the separator
        }}
      />
    </div>
  );
};

export default SelectStateCity;
